import { subWeeks, subMonths, subYears, startOfMonth, startOfYear } from "date-fns";

export type DateRangeKey = "1W" | "MTD" | "1M" | "3M" | "YTD" | "1Y" | "All";

export const DATE_RANGES: DateRangeKey[] = ["1W", "MTD", "1M", "3M", "YTD", "1Y", "All"];

/** Returns the ISO start date (YYYY-MM-DD) for the given range, or undefined for "All". */
export function getDateRangeStart(range: DateRangeKey): string | undefined {
  if (range === "All") return undefined;
  const today = new Date();
  let d: Date;
  switch (range) {
    case "1W":
      d = subWeeks(today, 1);
      break;
    case "MTD":
      d = startOfMonth(today);
      break;
    case "1M":
      d = subMonths(today, 1);
      break;
    case "3M":
      d = subMonths(today, 3);
      break;
    case "YTD":
      d = startOfYear(today);
      break;
    case "1Y":
      d = subYears(today, 1);
      break;
    default:
      return undefined;
  }
  return d.toISOString().slice(0, 10);
}
